import { z } from "zod";

export const personalizedNotificationTemplateFormSchema = z.object({
	title: z.string({
		required_error: "Titel ist erforderlich",
	}),
	message: z.string({
		required_error: "Nachricht ist erforderlich",
	}),
});
